/** Purpose: normalize agent references from string/object API shapes into IDs. Why: assignment notifications must compare IDs consistently across payload variants. */
const valuesFor = (value) => {
  if (!value) return [];
  if (typeof value === 'object') return [value._id, value.id, value.userId].filter(Boolean).map(String);
  return [String(value)];
};

/** Purpose: test whether two normalized ID collections share an entry. Why: assignment matching can handle multiple agent IDs with one reusable check. */
const hasIntersection = (left, right) => left.some((value) => right.has(value));

/** Purpose: detect conversations newly assigned to the current agent(s). Why: notification sound should fire only on a new assignment, not on initial Inbox load or already-resolved work. The caller seeds the previous snapshot before enabling this check. */
export const findNewAssignmentsForAgent = ({ conversations = [], previousConversations, agentIds = [] }) => {
  const currentAgentIds = new Set(agentIds.filter(Boolean).map(String));
  if (!currentAgentIds.size) return [];

  return conversations.filter((conversation) => {
    const id = String(conversation?._id || conversation?.id || '');
    if (!id) return false;
    if (['resolved', 'closed'].includes(String(conversation.status || '').toLowerCase())) return false;

    const assignedIds = valuesFor(conversation.assignedTo);
    if (!hasIntersection(assignedIds, currentAgentIds)) return false;

    const previous = previousConversations.get(id);
    const previousAssignedIds = valuesFor(previous?.assignedTo);
    return !hasIntersection(previousAssignedIds, currentAgentIds);
  });
};
